import { honoPrivateClient } from "@fd/frontend/api/honoClient";
import useSWR from "swr";

const $get = honoPrivateClient.traffic.usage.pools.$get;

async function fetcher() {
    const response = await $get();
    if (!response.ok) {
        throw new Error('Failed to fetch pool traffic usage');
    }
    return await response.json();
}

export default function usePoolTrafficUsage() {
  const response = useSWR('/traffic/usage/pools', fetcher);
  return response;
}